<script>
import Layout from '@layouts/main.vue'
import InvoiceSummary from '@components/finance/singleInvoice/invoice-summary.vue'
import InvoiceDetails from '@components/finance/singleInvoice/invoice-details.vue'
import InvoiceSummaryNo from '@components/finance/singleInvoice/invoice-summary-invoice-no.vue'
import InvoiceFilePreview from '@components/invoices/invoice-file-preview.vue'
import TimesheetFilePreview from '@components/finance/singleInvoice/timesheet-file-preview.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  metaInfo() {
    return {
      title: this.invoiceViewInvoiceData?.invoiceNumber
        ? this.$t('finance.invoiceViewWithIdPageTitle', {
            invoiceNumber: this.invoiceViewInvoiceData?.invoiceNumber,
          })
        : this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Invoice View page.' }],
    }
  },
  components: {
    Layout,
    InvoiceSummary,
    InvoiceDetails,
    InvoiceSummaryNo,
    InvoiceFilePreview,
    TimesheetFilePreview,
  },
  data() {
    return {
      invoiceViewInvoiceData: {},
      showInvoiceDownloadDialog: false,
      showTimesheetDownloadDialog: false,
      timesheetData: null,
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
  },
  async mounted() {
    var result = await this.getInvoiceByInvoiceNo(this.$route.params.invoiceNo)
    if (!result.isSuccess && result.statusCode === 403) {
      alert(this.$t('finance.invoiceViewUnauthorisedError'))
      this.$router.push('/finance')
    }

    if (result.isSuccess) {
      this.invoiceViewInvoiceData = result.data
    }
  },
  methods: {
    ...mapActions({
      getInvoiceByInvoiceNo: `singleInvoice/getInvoiceByInvoiceNo`,
    }),
    downloadInvoice() {
      this.showInvoiceDownloadDialog = true
    },
    downloadTimesheet(timesheetData) {
      this.timesheetData = timesheetData
      this.showTimesheetDownloadDialog = true
    },
  },
}
</script>

<template>
  <Layout>
    <div class="grey lighten-5 mb-6">
      <v-row>
        <v-col sm="0" md="0" lg="1"></v-col>
        <v-col xs="12" sm="12" md="12" lg="10">
          <v-row>
            <v-col cols="12" sm="4" md="3" class="ml-3">
              <div>
                <router-link to="/finance" class="simple-link-text">
                  <v-icon class="mr-1" color="blue" dense>
                    mdi-arrow-left
                  </v-icon>
                  <span class="blue--text">
                    {{ $t('finance.invoiceViewBacktoFinanceLinkLabel') }}</span
                  >
                </router-link>
              </div>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-4">
            <v-col cols="12" md="9">
              <InvoiceSummaryNo
                v-if="Object.keys(invoiceViewInvoiceData).length > 0"
                :invoice-summary-data="invoiceViewInvoiceData"
                @downloadInvoice="downloadInvoice"
              />
            </v-col>
            <v-col cols="12" md="3">
              <InvoiceSummary
                v-if="Object.keys(invoiceViewInvoiceData).length > 0"
                :invoice-summary-data="invoiceViewInvoiceData"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <InvoiceDetails
                v-if="Object.keys(invoiceViewInvoiceData).length > 0"
                :invoice-detail-data="invoiceViewInvoiceData"
                @downloadTimesheet="downloadTimesheet"
              />
            </v-col>
          </v-row> </v-col
      ></v-row>
    </div>
    <InvoiceFilePreview
      :show.sync="showInvoiceDownloadDialog"
      :invoice="invoiceViewInvoiceData"
    />
    <TimesheetFilePreview
      :show.sync="showTimesheetDownloadDialog"
      :timesheet-data="timesheetData"
    />
  </Layout>
</template>

<style lang="scss">
@import '@/styles/_colors.scss';
.simple-link-text {
  text-decoration: none;
  &.v-icon:hover {
    text-decoration: none;
  }
  span:hover {
    text-decoration: underline;
  }
}
</style>
